import { createStyles, makeStyles } from '@mui/styles';
import { Colors } from '../../../../layout/theme-next';
import { NextTheme } from '../../../../layout/theme-next/provider';

export const useStyles = makeStyles<NextTheme>((theme) => createStyles({
  popover: {
    // ...theme.overrides?.MuiMenu?.paper,
    marginLeft: 38,
  },
}));

export const useInputStyles = makeStyles<NextTheme>((theme) => createStyles({
  endAdorment: {
    cursor: 'pointer',
    height: 'auto',
    padding: theme.spacing(1.5),
    '&:hover': {
      color: Colors.textBlack,
    },
  },
  endAdormentDisabled: {
    color: Colors.textDisabled,
  },
  clear: {
    marginRight: theme.spacing(0.625),
  },
}));
